import React, { useEffect, useState } from "react";
import { Search } from "semantic-ui-react";
import _ from "lodash";
import ResultRenderer from "./ResultRenderer";

function SearchInput({ data, fn }) {
  const [isLoading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const [results, setResults] = useState([]);
  const [source, setSource] = useState([]);

  useEffect(() => {
    setSource(data);
  }, [data]);

  const handleResultSelect = (e, { result }) => {
    console.log("----", result);
    setValue(result.user ? result.user : result);
    fn(result);
  };

  const handleSearchChange = (e, { value }) => {
    setLoading(true);
    setValue(value);
    setTimeout(() => {
      if (value.length < 1) {
        setLoading(false);
        return setValue("");
      }
      const re = new RegExp(_.escapeRegExp(value), "i");
      const isMatch = (result) =>
        result.hasOwnProperty("user")
          ? re.test(result.user.firstName) ||
            re.test(result.user.lastName) ||
            re.test(result.user.role)
          : re.test(result.firstName) ||
            re.test(result.lastName) ||
            re.test(result.level);
      setLoading(false);
      setResults(_.filter(source, isMatch));
    }, 300);
  };

  return (
    <Search
      fluid
      loading={isLoading}
      onResultSelect={handleResultSelect}
      onSearchChange={_.debounce(handleSearchChange, 500, {
        leading: true,
      })}
      results={results}
      value={value.firstName}
      resultRenderer={(results) => <ResultRenderer results={results} />}
    />
  );
}

export default SearchInput;
